<template>
  <div>
    <base-crud
      crudName="Departamentos"
      newText="Novo Departamento"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="false"
      :dataForm="dataForm"
    >
    </base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "departmentsTable",
      // pages: [],
      // url: '',
      columns: [
        "id",
        "description",
        "multiple_reserves",
        "quantity_reserves",
        "user_id",
        "actions",
      ],
      tableData: [
        "id",
        "description",
        "multiple_reserves",
        "quantity_reserves",
        "user_id",
      ],
      options: {
        sortable: [
          "id",
          "description",
          "multiple_reserves",
          "quantity_reserves",
          "user_id",
        ],
        filterable: [
          "id",
          "description",
          "multiple_reserves",
          "quantity_reserves",
          "user_id",
        ],
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          description: "Descrição",
          multiple_reserves: "Multiplas Reservas",
          quantity_reserves: "Quantidade de Reservas",
          description: "Descrição",
          user_id: "Nome do Gestor",
          actions: "Ações",
        },
        templates: {
          user_id: function (h, row, index) {
            return row.user ? row.user.name : "Sem Nome";
          },
          multiple_reserves: function (h, row, index) {
            return row.multiple_reserves == 1 ? "Sim" : "Não";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["user"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "departments/",

      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        description: "description",
        user_id: "user[name]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Department/Crud.vue